import SectionIntro from "./SectionIntro";
import { channels } from "@/mocks/softwareData";

const accentMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-600",
};

export default function QuickChannels() {
  return (
    <section id="channels" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionIntro
          eyebrow="DOWNLOAD CHANNEL"
          title="按你的设备挑一条下载通道"
          desc="每个入口都对应不同平台与版本形态，先选对通道再下载，少走弯路。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((c) => (
            <a
              key={c.title}
              href="#releases"
              className="group flex items-start gap-4 rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200 hover:bg-primary-50"
            >
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${accentMap[c.accent]}`}>
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-display text-base font-bold text-foreground-950">{c.title}</span>
                  <span className="shrink-0 rounded-full bg-background-50 px-2 py-0.5 text-xs font-semibold text-primary-600">
                    {c.count}
                  </span>
                </span>
                <span className="mt-1 block text-sm leading-relaxed text-foreground-600">{c.desc}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}